import AbstractConfig from "../../../core/config/AbstractConfig";

export default class CharactersConfig extends AbstractConfig {
    /**
     * @returns {Array<CharacterConfig>} 
     */
    get characters() {
        return this.getValue("characters")
            .map(data => new CharacterConfig(data));
    }
}

export class CharacterConfig {
    constructor(data) {
        this._data = data;
    }

    /**
     * @returns {string}
     */
    get id() {
        return this._data.id;
    }

    /**
     * @returns {string}
     */
    get name() {
        return this._data.name;
    }

    /**
     * @returns {string}
     */
    get avatarImageId() {
        return this._data.avatarImageId;
    }

    /**
     * @returns {Array<string>}
     */
    get emotions() {
        return this._data.emotions;
    }

    /**
     * @returns {Array<TrackerConfig>}
     */
    get trackers() {
        return this._data.trackers.map(data => new TrackerConfig(data));
    }

    toObject() {
        return {
            id: this.id,
            name: this.name,
            avatarImageId: this.avatarImageId,
            emotions: this.emotions,
            trackers: this.trackers.map(tracker => tracker.toObject()),
        };
    }
}

export class TrackerConfig {
    constructor(data) {
        this._data = data;
    }

    /**
     * @returns {string}
     */
    get id() {
        return this._data.id;
    }

    /**
     * @returns {number}
     */
    get startingValue() {
        return this._data.startingValue;
    }

    toObject() {
        return {
            id: this.id,
            startingValue: this.startingValue,
        };
    }
}